import { makeStyles, useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import clsx from 'clsx'
import React from 'react'
import 'react-image-gallery/styles/css/image-gallery.css'
import IframeComponent from './IframeComponent'
import { VideoSource } from './ListingDetailMediaCarousel'

const useEmbeddedVideoStyles = makeStyles((theme) => ({
    container: {
        width: 800,
        height: 600,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            width: 514.85,
            height: 386,
        },
    },
    theater: {
        background: '#000',
    },
}))

export interface EmbeddedVideoProps {
    /**
     * Video ID.
     */
    videoId: string

    /**
     * Can either be YouTube or Vimeo.
     *
     * May add support for other platforms in the future.
     */
    videoSource: VideoSource

    className?: string | string[]
}

/**
 *  Generates embedded video players for
 *  YouTube or Vimeo content.
 */
const EmbeddedVideo: React.FC<EmbeddedVideoProps> = ({
    videoId,
    videoSource,
    className,
}) => {
    const classes = useEmbeddedVideoStyles()
    const theme = useTheme()
    const mdDown = useMediaQuery(theme.breakpoints.down('md'))

    return (
        <div
            className={clsx(
                classes.container,
                'listingDetailEmbeddedVideo',
                className
            )}
        >
            <IframeComponent
                videoSource={videoSource}
                videoId={videoId}
                mdDown={mdDown}
            />
        </div>
    )
}

export default EmbeddedVideo
